import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_store_interaction } from '../../_fields/_base/_enums/ENUM__field_store_interaction';
import { FIELD_PRIMITIVE__float } from '../../_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__string_enum } from '../../_fields/_primitives/string/FIELD_PRIMITIVE__string_enum';
import { ENUM__image_asset_category } from '../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../_fields/image/FIELD__image_asset';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__field_role } from '../_base/ENUM__field_role';
import { ENUM__invocation_type } from '../_base/ENUM__invocation_type';
import { INVOCATION__base } from '../_base/INVOCATION__base';
import { ENUM__image_resampling_mode } from './ENUM__image_resampling_mode';

export class INVOCATION_IMAGE__scale extends INVOCATION__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_IMAGE__SCALE;

  @FIELD__image_asset.init_as_input_transform_none(
    { category: ENUM__image_asset_category.IMAGE },
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_CONNECTABLE,
      field_role: ENUM__field_role.IMAGE__MAIN,
      store__interaction: ENUM__field_store_interaction.READ_AND_WRITE,
    },
  )
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__float.init_as_input(
    {
      value: 1.2,
      value_range: CONSTANTS_GENERATION__value_range.ZERO_TO_10,
      values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_10,
      //
      slider_step: 1,
      slider_step_values: [1, 2, 5],
    },
    { field_role: 'Scale Factor' },
  )
  scale_factor!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__image_resampling_mode.BICUBIC, ENUM__image_resampling_mode)
  resample_mode!: FIELD_PRIMITIVE__string_enum;

  /*
   *
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.IMAGE })
  out!: FIELD__image_asset;

  /*
   *
   */
  constructor() {
    super(ENUM__invocation_type.IMAGE__SCALE);
  }

  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance): boolean {
    if (this.scale_factor.find_source(graph).get_value() == 1) return false;

    return super.has_effect_on_generation_runtime(graph);
  }
}
